import { useState, useEffect } from 'react';
import { Button, Input } from 'semantic-ui-react';
import { errorInput } from '../../components/helpers';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from '../../components/helpers/recaptchaUtils';
import useRememberCredentials from '../../components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from '../../components/helpers/RememberCredentialsCheckbox';
import queryString from 'query-string';
import { GuestLoginDashboardComponent } from './styles/GuestLoginStyles';
import { RegistrationSection, RegistrationForm } from 'src/assets/styles/components/Registration';

const GuestLogin = (props) => {
  const { getInfo } = props;
  const [errorInputs, set_errorInputs] = useState({});
  const [Inputs, set_Inputs] = useState({});
  const [loading, set_loading] = useState(false);
  const [securityError, setSecurityError] = useState('');
  const getCaptchaToken = useRecaptchaToken('crecer_attendance');
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs: set_Inputs });

  useEffect(() => {
    const parsed = queryString.parse(window.location.search);
    const id = parsed.identification?.trim();
    const phone = parsed.phone?.trim();
    if (id || phone) {
      set_Inputs((prev) => ({
        ...prev,
        ...(id && { identification: id }),
        ...(phone && { phone }),
      }));
    }
  }, []);

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_loading(true);
    setSecurityError('');

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      setSecurityError(RECAPTCHA_SECURITY_ERROR);
      set_loading(false);
      return;
    }

    persistCredentials({
      identification: Inputs.identification,
      phone: Inputs.phone,
    });

    await getInfo({
      ...Inputs,
      ...(captchaRequired ? { captcha } : {}),
    });
    set_loading(false);
  };

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: Inputs[input] },
      });
    });

    if (Inputs['identification'] && Inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: Inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    set_Inputs({ ...Inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  return (
    <GuestLoginDashboardComponent>
      <RegistrationSection>
        <h1>¡Bienvenido!</h1>
        <h4>Por favor ingresa tus datos para ingresar a tu perfil</h4>
        <RegistrationForm onSubmit={enterReservation}>
          {Object.values(errorInputs).includes(true) && (
            <h4 className="Registration__error-message">Por favor verifica los campos en rojo.</h4>
          )}
          <Input
            onChange={handleInputs}
            name={'identification'}
            value={Inputs.identification}
            type="number"
            placeholder="Identificación"
            id="identification"
            className={`Registration__input ${errorInputs['identification'] ? 'error' : ''}`}
          />
          <Input
            placeholder="Celular"
            id="phone"
            name={'phone'}
            type="number"
            className={`Registration__input ${errorInputs['phone'] ? 'error' : ''}`}
            value={Inputs.phone}
            onChange={handleInputs}
          />
          <RememberCredentialsCheckbox
            checked={rememberCredentials}
            onChange={setRememberCredentials}
          />
          {securityError && <p className="Registration__captcha-error">{securityError}</p>}
          <Button primary disabled={loading} type="submit">
            Entrar
          </Button>
        </RegistrationForm>
      </RegistrationSection>
    </GuestLoginDashboardComponent>
  );
};

export default GuestLogin;
